export function sleep(n: number) {
  return new Promise((resolve) => setTimeout(resolve, n));
}

// Snowで使われているpoll関数を借用
export function poll<T>(
  getState: () => Promise<T>,
  resolveCond: (state: T) => boolean,
  rejectCond: (state: T) => boolean,
  interval: number
): readonly [() => void, Promise<T>] {
  let disposed = false;
  let timeoutId: any = null;
  const checkCond = async (resolve: Function, reject: Function) => {
    const state = await getState();
    if (disposed) {
      return;
    }
    if (resolveCond(state)) {
      resolve(state);
    } else if (rejectCond(state)) {
      reject(state);
    } else {
      timeoutId = setTimeout(checkCond, interval, resolve, reject);
    }
  };
  const dispose = () => {
    disposed = true;
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
  };
  const promise: Promise<T> = new Promise(checkCond);
  return [dispose, promise] as const;
}
